import React from 'react';
import { fetchReferrals } from 'actions/referrals';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import moment from 'moment';
import { date } from 'utils/date';
import { dollars } from 'utils/money';
import { Link } from 'react-router-dom';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import CircularProgress from '@material-ui/core/CircularProgress';
import Snackbar from '@material-ui/core/Snackbar';
import Divider from '@material-ui/core/Divider';
import { toggleNotification } from '/actions/commonActions';

import Form from 'components/Referrals/Form';

const styles = theme => ({});

export class List extends React.Component {
  componentDidMount() {
    this.props.dispatch(fetchReferrals());
  }

  renderSpinner = () => {
    if (this.props.showSpinner) {
      return (
        <CircularProgress color='primary' thickness={7} style={{position: 'absolute', zIndex: '1', top: '50%', left: '50%'}}/>
      );
    }
  }

  renderReferrals = (referrals) => {
    return (
      <Table data-test='referralsTable'>
        <TableHead>
          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell>Email</TableCell>
            <TableCell>Wechat</TableCell>
            <TableCell>Manager</TableCell>
            <TableCell>Bank Account</TableCell>
            <TableCell>Location Type</TableCell>
            <TableCell>Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          { Object.values(referrals).map(this.renderReferral) }
        </TableBody>
      </Table>
    );
  }

  renderReferral = (referral) => {
    const { classes } = this.props;

    return (
      <TableRow key={referral.id}>
        <TableCell>
          {`${referral.firstName} ${referral.lastName}`}
        </TableCell>
        <TableCell>
          {referral.email}
        </TableCell>
        <TableCell>
          {referral.wechat}
        </TableCell>
        <TableCell>
          {referral.manager}
        </TableCell>
        <TableCell>
          {referral.bankAccount}
        </TableCell>
        <TableCell>
          {referral.locationType}
        </TableCell>
        <TableCell>
          <Form
            buttonStyles={classes.headerButton}
            buttonLabel='Edit'
            mode='update'
            referralId={referral.id}
            form={`updateReferral${referral.id}`}
          />
        </TableCell>
      </TableRow>
    );
  }

  render = () => {
    const { referrals, classes } = this.props;

    return (
      <div>
        <div style={{ display: 'flex' }}>
          <Typography variant='headline' className={classes.flex}>
            Referrals
          </Typography>
          <Form
            buttonStyles={classes.headerButton}
            buttonLabel='Add Referral'
            mode='create'
            form='createReferral'
          />
        </div>
        <Divider light />
        { referrals ? this.renderReferrals(referrals) : this.renderSpinner() }
      </div>
    );
  };
}

const mapStateToProps = (state, ownProps) => {
  const { referrals } = state.referrals;
  return { referrals };
};

const styled = withStyles(styles)(List)
const connected = connect(mapStateToProps)(styled);
export default connected;



// WEBPACK FOOTER //
// ./src/components/Referrals/List.js